// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"CloseButton_closeButton__kh019","fadeIn":"CloseButton_fadeIn__dx4xy"};